function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.2495 10.3672C7.2495 10.9473 7.47997 11.5037 7.89021 11.914C8.30044 12.3242 8.85684 12.5547 9.437 12.5547C10.0172 12.5547 10.5736 12.3242 10.9838 11.914C11.394 11.5037 11.6245 10.9473 11.6245 10.3672C11.6245 9.78703 11.394 9.23063 10.9838 8.82039C10.5736 8.41016 10.0172 8.17969 9.437 8.17969C8.85684 8.17969 8.30044 8.41016 7.89021 8.82039C7.47997 9.23063 7.2495 9.78703 7.2495 10.3672ZM17.9175 9.86328C16.0659 5.96289 13.2671 4 9.51513 4C5.76122 4 2.96435 5.96289 1.11278 9.86523C1.03852 10.0225 1 10.1942 1 10.3682C1 10.5421 1.03852 10.7138 1.11278 10.8711C2.96435 14.7715 5.76317 16.7344 9.51513 16.7344C13.269 16.7344 16.0659 14.7715 17.9175 10.8691C18.0679 10.5527 18.0679 10.1855 17.9175 9.86328ZM9.437 13.8047C7.53856 13.8047 5.9995 12.2656 5.9995 10.3672C5.9995 8.46875 7.53856 6.92969 9.437 6.92969C11.3354 6.92969 12.8745 8.46875 12.8745 10.3672C12.8745 12.2656 11.3354 13.8047 9.437 13.8047Z",
  fill: "#697578"
});

var SvgEyeFilled = function SvgEyeFilled(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEyeFilled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eye-filled.8ab3a017.svg";
export { ForwardRef as ReactComponent };